export const PRICING_MODEL = Object.freeze({
  PAYG: 'PRICING_MODEL_PAYG',
  FLEX: 'PRICING_MODEL_FLEX',
  ENTITLEMENT: 'PRICING_MODEL_ENTITLEMENT',
  UNSPECIFIED: 'PRICING_MODEL_UNSPECIFIED',
});
